import styled, { createGlobalStyle } from "styled-components";

export const PaicModalGlobal = createGlobalStyle`
  .paic-confirm-modal .ant-btn-primary {
    background-color: ${p => p.theme?.colors?.primary ?? '#008080'} !important;
  }
  .paic-confirm-modal .ant-btn-default:hover {
    color: ${p => p.theme?.colors?.primary ?? '#008080'} !important;
    border-color: ${p => p.theme?.colors?.primary ?? '#008080'} !important;
  }
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.cardBg ?? theme.colors.white};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight ?? '#E5E7EB'};
  box-shadow: 0 2px 12px rgba(16, 24, 64, 0.08);

  /* Table surface follows the card color (cardBg) */
  .ant-table { background: transparent; }
  .ant-table-tbody > tr > td { background: transparent; }
`;

export const HeaderSection = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  flex-shrink: 0;
`;

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: 1200px) {
    flex-wrap: wrap;
  }
`;

export const RefreshButton = styled.button`
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.focusShadow};
  }
`;

export const HeaderActionsPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 680px;
  flex-shrink: 0;

  @media (max-width: 1200px) {
    width: 100%;
    flex-shrink: 1;
  }
`;

export const ManageGroupsBtnWrapper = styled.div`
  flex-shrink: 0;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    height: 32px;
    padding: 0 10px;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    border-radius: 6px;
    background: transparent;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    transition: all 0.2s;

    .anticon {
      font-size: 14px;
    }

    &:hover {
      background: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
      box-shadow: 0 2px 8px ${({ theme }) => theme.colors.focusShadow};
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.focusShadow};
    }
  }
`;

export const TopActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const SearchWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SearchIconBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};

  .anticon {
    font-size: 14px;
    color: inherit;
  }
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
`;

export const GroupControlWrapper = styled.div`
  width: 330px;
  flex-shrink: 0;

  .ant-select, .ant-input-affix-wrapper {
    width: 100%;
  }

  @media (max-width: 1200px) {
    flex: 1;
    width: auto;
  }
`;

export const CreateGroupRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 38px;
`;

export const CreateGroupLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
  flex-shrink: 0;
`;

export const EvaluateButtonWrapper = styled.div`
  flex-shrink: 0;

  button {
    min-width: 200px;
    width: auto;
    height: 36px;
    padding: 0 16px;
    font-size: 13px;
    white-space: nowrap;
  }
`;

export const PAICProgressPanel = styled.div`
  padding: 10px 12px;
  border: 1px solid ${({ $failed, theme }) =>
    $failed
      ? theme.colors.statusFailed || "#ff4d4f"
      : `${theme.colors.primary || "#008080"}30`};
  border-radius: 10px;
  background: ${({ $failed, theme }) =>
    $failed ? "#fff2f0" : `${theme.colors.primary || "#008080"}08`};
`;

export const PAICProgressHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ $failed, theme }) =>
    $failed ? theme.colors.statusFailed || "#cf1322" : theme.colors.dark};
`;

export const PAICProgressTrack = styled.div`
  height: 7px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.borderLight || "#f0f0f0"};
  overflow: hidden;
`;

export const PAICProgressFill = styled.div`
  height: 100%;
  width: ${({ $progress }) => `${Math.max(0, Math.min(Number($progress) || 0, 100))}%`};
  background: ${({ $failed, theme }) =>
    $failed ? theme.colors.statusFailed || "#ff4d4f" : theme.colors.primary};
  transition: width 0.3s ease;
`;

export const PAICProgressMeta = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: ${({ $failed, theme }) =>
    $failed ? theme.colors.statusFailed || "#cf1322" : theme.colors.gray || "#666"};
  line-height: 1.4;
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

export const OptionText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.dark};
`;

export const BadgeGroup = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

export const SourceBadge = styled.span`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({ $source }) => {
    if ($source === "owned") return "#e6f7f0";
    if ($source === "delegated") return "#fff7e6";
    if ($source === "shared") return "#e6f0ff";
    return "#f0f0f0";
  }};
  color: ${({ $source }) => {
    if ($source === "owned") return "#0d7e5f";
    if ($source === "delegated") return "#d97706";
    if ($source === "shared") return "#1d4ed8";
    return "#666";
  }};
`;

export const StatusBadge = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 86px;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};
  background: ${({ status, theme }) => {
    if (status === "Processing") return theme.colors.statusProcessing;
    if (status === "Completed") return theme.colors.statusCompleted;
    if (status === "Failed") return theme.colors.statusFailed;
    return theme.colors.statusDefault;
  }};
`;

export const paicConfirmOkButtonProps = (theme) => ({
  style: {
    backgroundColor: theme.colors.primary,
    borderColor: theme.colors.primary,
    borderRadius: "6px",
    fontWeight: 600,
  },
});

export const paicConfirmCancelButtonProps = {
  style: {
    borderRadius: "6px",
    fontWeight: 600,
  },
};

export const paicConfirmModalStyles = {
  body: {
    paddingTop: "8px",
    paddingBottom: "8px",
  },
};

export const TableSection = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
`;

export const PAICTableWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .ant-table-pagination {
    position: sticky;
    bottom: 0;
    background: ${({ theme }) => theme.colors.white};
    padding: 12px 16px;
    margin: 0 !important;
    border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
  }

  .ant-pagination-total-text {
    margin-right: auto !important;
  }

  .ant-table-thead > tr > th {
    white-space: nowrap;
  }

  .paic-pagination-total {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .paic-pagination-total .is-active-text {
    color: ${({ theme }) => theme.colors.primary};
  }

  .paic-pagination-total .is-empty-text {
    color: ${({ theme }) => theme.colors.gray};
  }
`;